import { Component } from '@angular/core';

@Component({
  template: '<div class="inner-banner"><div class="container"><div class="inner-banner-text text-center"></div></div></div><h2 class="notFound">Page not found</h2>'
})
export class PageNotFoundComponent {}



// WEBPACK FOOTER //
// ./src/app/not-found.component.ts